exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".redirect-dialog[data-v-52af6ee4] .el-dialog__body{padding:15px 25px 0px}\n", ""]);

// exports
